import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const center = objectWithClassName({
  className: [
    `text-center`,
    /** @deprecated Use 'text-center' instead */
    "umd-layout-text-alignment-center"
  ]
});
export {
  center
};
//# sourceMappingURL=inline.js.map
